<template>
  <div class="PageDependentEdit">
    <v-toolbar-title>Compartilhar {{dependent.name}}</v-toolbar-title>
    <form-share-dependent :dependent="dependent" />
  </div>
</template>
<script>
import { getDependent } from '../../utils'
import FormShareDependent from '../forms/FormShareDependent.vue'

export default {
  components: { FormShareDependent },
  name:'PageDependentShare',
  data: function () {
    return {
      dependent: {}
    }
  },
  methods: {
    loadDependent: function() {
      this.dependent = getDependent()
    }
  },
  mounted: function () {
    this.loadDependent()
  }
}
</script>
